import React from "react";
import { BannerSection } from "./styles";

const Banner = () => {
    return(
        <BannerSection>
            <h2>Juegos recomendados</h2>
            <p>Descubre juegos</p>
        </BannerSection>
    )
}

export default Banner;